import React from 'react'
import Dashbord from './components/Dashbord'

const index = () => {
  return (
    <React.Fragment> 
      <Dashbord/>
    </React.Fragment>
  )
}

export default index